import { array, func, string } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import CustomTable from '../CustomTable/CustomTable';
import OffersListItem from './OffersListItem';

const propTypes = {
  offers: array.isRequired,
  onRequestOfferAccess: func,
  onFlowCreate: func.isRequired,
  sortOrder: string.isRequired,
  sortBy: string.isRequired,
  onUnavailableOfferClick: func.isRequired,
};

const defaultProps = {
  offers: [],
  onRequestOfferAccess() {},
};

const OffersList = ({
  offers,
  offerSettings,
  onRequestOfferAccess,
  onFlowCreate,
  sortOrder,
  sortBy,
  handleSort,
  countries,
  currencies,
  tab,
  onUnavailableOfferClick,
}) => {
  const similarGmOffers = ['gambling', 'finances'].some((t) => t === tab);

  return (
    <CustomTable className="offers-list" responsive condensed aria-label="Offers">
      <CustomTable.Wrapper>
        <CustomTable.Row>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="title"
            handleSort={handleSort}
            defaultSortOrder="asc"
            sorting
            className="offers-list-values"
          >
            <span>
              <FormattedMessage id="offers.table.offer" defaultMessage="Offer" />
              <span className="sorting-icons-offers" />
            </span>
          </CustomTable.Cell>

          <CustomTable.Cell>
            <div className="offer-pixel-cell">
              <div className="target pr-3">
                <FormattedMessage id="offers.table.target.theme_1-3" defaultMessage="Target" />
              </div>
              <div className={`prices ${similarGmOffers && 'prices--w50'} grid-custom-layout`}>
                {/* <div className="geo pr-3">
                  <span id="table-cell-geo">
                    <FormattedMessage id="offers.table.geo" defaultMessage="Geo" />
                  </span>
                  <UncontrolledTooltip target="table-cell-geo" placement="bottom">
                    <FormattedMessage id="offers.table.allow-geos" defaultMessage="Geo" />
                  </UncontrolledTooltip>
                </div>
                {!similarGmOffers && (
                  <div className="price">
                    <span id="table-cell-price">
                      <FormattedMessage id="offers.table.price" defaultMessage="Price" />
                    </span>
                    <UncontrolledTooltip target="table-cell-price" placement="bottom">
                      <FormattedMessage id="offers.table.prices" defaultMessage="Prices" />
                    </UncontrolledTooltip>
                  </div>
                )} */}
                <div className="rate pr-3 d-flex justify-content-end">
                  <CustomTable.Cell
                    className="text-right p-0 border-0 min-w-unset w-auto table-cell-rate-offer"
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    sortName="payout"
                    handleSort={handleSort}
                    defaultSortOrder="asc"
                    sorting
                  >
                    <span id="table-cell-rate">
                      <span>
                        <FormattedMessage id="offers.table.payout" defaultMessage="Payout" />
                        <span className="sorting-icons-offers" />
                      </span>
                    </span>
                  </CustomTable.Cell>
                  <UncontrolledTooltip target="table-cell-rate" placement="bottom">
                    <FormattedMessage id="offers.table.payout-order" defaultMessage="Geo" />
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
          </CustomTable.Cell>

          {!similarGmOffers && (
            <CustomTable.Cell
              className="text-left"
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="rate"
              handleSort={handleSort}
              defaultSortOrder="asc"
              sorting
            >
              <span id="table-approve">
                <span>Apr%</span>
                <span className="sorting-icons-offers" />
              </span>
              <UncontrolledTooltip target="table-approve" placement="top">
                Общий % подтвержденных заказов
              </UncontrolledTooltip>
            </CustomTable.Cell>
          )}

          {!similarGmOffers && (
            <CustomTable.Cell
              className="text-left"
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="cr"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <span id="table-cr">CR</span>
              <UncontrolledTooltip target="table-cr" placement="top">
                Конвертация кликов в лиды
              </UncontrolledTooltip>
              <span className="sorting-icons-offers" />
            </CustomTable.Cell>
          )}

          {!similarGmOffers && (
            <CustomTable.Cell
              className="text-left"
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="epc"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <span id="table-epc">
                <span>EPC</span>
              </span>
              <UncontrolledTooltip target="table-epc" placement="top">
                Профит за один клик
              </UncontrolledTooltip>
              <span className="sorting-icons-offers" />
            </CustomTable.Cell>
          )}
          <CustomTable.Cell>
            <span>Действие</span>
          </CustomTable.Cell>
        </CustomTable.Row>
      </CustomTable.Wrapper>

      {offers.length > 0 && (
        <CustomTable.Wrapper type="body">
          {offers.map((offer) => (
            <OffersListItem
              tab={tab}
              key={offer.id}
              {...offer}
              onRequestOfferAccess={onRequestOfferAccess}
              onFlowCreate={onFlowCreate}
              offerSettings={offerSettings}
              countries={countries}
              globalCurrencies={currencies}
              similarGmOffers={similarGmOffers}
              onUnavailableOfferClick={onUnavailableOfferClick}
            />
          ))}
        </CustomTable.Wrapper>
      )}
    </CustomTable>
  );
};

OffersList.propTypes = propTypes;
OffersList.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  offerSettings: state.app.settings.offer,
  countries: state.app.globalSettings.countries,
  manager: state.webmaster.manager,
});

export default connect(mapStateToProps)(OffersList);
